
export const common = {
  // Navigation
  'nav.home': 'Inicio',
  'nav.services': 'Servicios',
  'nav.techStack': 'Tecnologías',
  'nav.about': 'Nosotros',
  'nav.contact': 'Contacto',
  'nav.getQuote': 'Cotizar',

  // Company Info
  'company.name': 'Balam Technology',
  'company.tagline': 'Software personalizado, construido con confianza.',

  // Hero Section
  'hero.title': 'Construimos el futuro con software personalizado.',
  'hero.subtitle': 'Innovación, confianza, tecnología moderna.',
  'hero.cta': 'Contáctanos',
  'hero.learnMore': 'Conoce Más',

  // Services Section
  'services.title': 'Nuestros Servicios',
  'services.subtitle': 'UI moderna, backends escalables, APIs seguras, implementaciones en la nube.',
  'services.getQuote': 'Obtener Cotización',
  
  'services.website.title': 'Desarrollo Web',
  'services.website.description': 'UI moderna con diseño responsivo y rendimiento optimizado.',
  'services.website.benefits': 'Rápido, amigable con SEO, enfoque mobile-first',
  
  'services.landing.title': 'Landing Pages',
  'services.landing.description': 'Páginas de alta conversión que generan resultados para tu negocio.',
  'services.landing.benefits': 'Optimizado para conversión, probado A/B, listo para analytics',
  
  'services.webapp.title': 'Aplicaciones Web',
  'services.webapp.description': 'Aplicaciones web escalables con arquitectura moderna y UX.',
  'services.webapp.benefits': 'Backends escalables, arquitectura segura, listo para la nube',
  
  'services.api.title': 'Desarrollo de APIs',
  'services.api.description': 'APIs seguras con documentación robusta y monitoreo.',
  'services.api.benefits': 'Diseño RESTful, endpoints seguros, documentación completa',

  // Tech Stack Section
  'techStack.title': 'Nuestro Stack Tecnológico',
  'techStack.subtitle': 'Utilizamos AWS, React, JavaScript, Tailwind, arquitecturas Serverless y Monolíticas para construir soluciones robustas y escalables.',
  'techStack.architecture.title': 'Arquitectura que Escala',
  'techStack.architecture.description': 'Elegimos la arquitectura correcta para tus necesidades - desde soluciones serverless para escalado rápido hasta enfoques monolíticos cuando tu proyecto lo demanda. Cada decisión se toma pensando en el rendimiento, mantenibilidad y tus objetivos de negocio.',
  
  'techStack.aws.description': 'Infraestructura y servicios en la nube',
  'techStack.react.description': 'Framework moderno de frontend',
  'techStack.javascript.description': 'Lenguaje de programación principal',
  'techStack.tailwind.description': 'Framework CSS utility-first',
  'techStack.serverless.description': 'Arquitectura serverless escalable',
  'techStack.monolithic.description': 'Cuando la arquitectura lo demanda',

  // About Section
  'about.title': 'Una empresa joven con estándares senior.',
  'about.description': 'Somos apasionados por entregar soluciones de software de calidad. Nuestro flujo de trabajo: descubrimiento → diseño → desarrollo → implementación.',
  'about.workflow.discovery': 'Descubrimiento',
  'about.workflow.design': 'Diseño',
  'about.workflow.develop': 'Desarrollo',
  'about.workflow.deploy': 'Implementación',
  'about.satisfaction': 'Satisfacción del Cliente',
  'about.excellence': 'Excelencia garantizada en cada proyecto',
  'about.quality': 'Calidad Premium',
  'about.delivery': 'Entrega Puntual',
  'about.support': 'Soporte',
  'about.innovation.title': 'Innovación',
  'about.innovation.description': 'Soluciones de vanguardia usando las últimas tecnologías',
  'about.trust.title': 'Confianza',
  'about.trust.description': 'Asociaciones confiables construidas sobre transparencia',
  'about.modernTech.title': 'Tecnología Moderna',
  'about.modernTech.description': 'Soluciones a prueba de futuro que escalan con tu negocio',

  // Contact Section
  'contact.title': 'Cuéntanos sobre tu proyecto',
  'contact.subtitle': '¿Listo para dar vida a tus ideas? Discutamos los requisitos de tu proyecto.',
  'contact.form.name': 'Nombre Completo',
  'contact.form.email': 'Correo Electrónico',
  'contact.form.company': 'Nombre de la Empresa',
  'contact.form.project': 'Tipo de Proyecto',
  'contact.form.budget': 'Rango de Presupuesto',
  'contact.form.message': 'Detalles del Proyecto',
  'contact.form.submit': 'Enviar Mensaje',
  'contact.form.sending': 'Enviando...',
  'contact.form.success': '¡Gracias! Te responderemos dentro de 24 horas.',
  'contact.form.error': 'Algo salió mal. Por favor intenta de nuevo o envíanos un email directamente.',
  'contact.form.charactersLeft': 'caracteres',
  
  'contact.form.placeholders.name': 'Juan Pérez',
  'contact.form.placeholders.email': 'juan@empresa.com',
  'contact.form.placeholders.company': 'Tu Empresa',
  'contact.form.placeholders.message': 'Cuéntanos sobre los requisitos de tu proyecto, cronograma y cualquier característica específica que necesites...',
  
  'contact.form.projectTypes.select': 'Selecciona un servicio',
  'contact.form.projectTypes.website': 'Desarrollo Web',
  'contact.form.projectTypes.landing': 'Landing Page',
  'contact.form.projectTypes.webapp': 'Aplicación Web',
  'contact.form.projectTypes.api': 'Desarrollo de API',
  'contact.form.projectTypes.other': 'Otro',
  
  'contact.form.budgetRanges.select': 'Selecciona presupuesto',
  'contact.form.budgetRanges.5k10k': '$5K - $10K',
  'contact.form.budgetRanges.10k25k': '$10K - $25K',
  'contact.form.budgetRanges.25k50k': '$25K - $50K',
  'contact.form.budgetRanges.50kplus': '$50K+',

  // CAPTCHA Section
  'contact.form.captcha.title': 'Verificación de Seguridad',
  'contact.form.captcha.instruction': 'Por favor resuelve el problema matemático para verificar que eres humano',
  'contact.form.captcha.refresh': 'Generar nuevo problema',
  'contact.form.captcha.error': 'Respuesta incorrecta. Por favor resuelve el problema matemático correctamente.',

  'contact.info.title': 'Ponte en Contacto',
  'contact.info.email': 'Email',
  'contact.info.phone': 'Teléfono',
  'contact.info.responseTime': 'Tiempo de Respuesta',
  'contact.info.responseTimeValue': 'Dentro de 24 horas',
  'contact.followUs': 'Síguenos',

  // Footer
  'footer.description': 'Software personalizado, construido con confianza. Creamos soluciones innovadoras usando tecnologías modernas para ayudar a tu negocio a prosperar en la era digital.',
  'footer.quickLinks': 'Enlaces Rápidos',
  'footer.services': 'Servicios',
  'footer.copyright': '© 2024 Balam Technology. Todos los derechos reservados.',
  'footer.madeWith': 'Powered by Balam Technology',

  // Services list for footer
  'footer.services.website': 'Desarrollo Web',
  'footer.services.landing': 'Landing Pages',
  'footer.services.webapp': 'Aplicaciones Web',
  'footer.services.api': 'Desarrollo de APIs',

  // Common
  'common.required': '*'
};

export default common;
